export default "/images/vendor/flag-icon-css/flags/1x1/ly.svg?9d867c1b9d3b76652858a0c5505718bb";